import type { ErrorComponentProps } from "@tanstack/react-router";
import ErrorLayout from "./ErrorOrNotFoundPage";

const DefaultErrorPage = (props: ErrorComponentProps) => {
  return <ErrorLayout title="Oops, something went wrong" {...props} />;
};

export default DefaultErrorPage;
